import { Routes, Route } from 'react-router-dom'; 
import { DashboardLayout } from '@/layouts/DashboardLayout';
import { AuthLayout } from '@/layouts/AuthLayout';
import { ProtectedRoute } from '@/components/common/ProtectedRoute';
import { NotFoundPage } from '@/pages/NotFoundPage';
import LoginPage from './pages/auth/LoginPage';
import EventListing from './pages/EventListing';
import Render from './pages/RenderCheck/Render';

// const HomeLayoutShortFooter = loadable(() => import('@/pages/EventListing'), {
//   fallback: <Loader />,
// });

export function App() {
  return (
    <Routes>
      {/* Auth Routes */}
      <Route element={<AuthLayout />}>
        <Route index path="/login" element={<LoginPage />} />
      </Route>

      <Route element={<ProtectedRoute />}>
        <Route element={<DashboardLayout />}>
          <Route path="/" element={<EventListing />} />
        </Route>
      </Route>
      <Route path="/render" element={<Render />} />

      {/* 404 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
